export default function observationCategoryColor(
  category:
    'positive' | 'negative' | 'question' | 'neutral' /*, positionalB, named*/,
) {
  if (category === 'positive') return 'bg-green-500/10 text-green-500';
  if (category === 'negative') return 'bg-red-500/10 text-red-500';
  if (category === 'neutral') return 'bg-gray-50 text-gray-500';
  if (category === 'question') return 'bg-purple-600/10 text-purple-600';
  return '';
}
